import React, { useEffect, useState } from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import axios from "axios";

const SalesBarChart2 = ({ endpoint, barChartTitle, barColor, yAxisTitle }) => {

  let branch_code_from_local_storage = localStorage.getItem("currentSelectedDepartment");
  let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"

  const [loading, setLoading] = useState(true);
  const [chartData, setChartData] = useState([]);

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const todayDate = getTodayDate();

  useEffect(() => {
    fetchChartData(endpoint, setChartData, setLoading);
  }, [endpoint]);

  const fetchChartData = async (endpoint, setChartData, setLoading) => {
    try {
      const response = await axios.get(
        `https://cubixweberp.com:213/api/HRDashboard/${company_code_from_local_storage}/${branch_code_from_local_storage}/${endpoint}/2024-01-01/${todayDate}/-/-/-/-/-`
      );
      setChartData(response.data);
      console.log(" data:", response.data);
    } catch (error) {
      // console.error("Error fetching chart data:", error);
    } finally {
      setLoading(false);
    }
  };

  // const salesperson = chartData.map((item) => item.SalespersonName?.trim());
  // const coordinatorName = chartData.map((item) => item.CoordinatorName?.trim());
  // const newCustomers = chartData.map((item) => item.NewCustomers);
  // const month = chartData.map((item) => item.Month?.trim());
  const totalOrders = chartData.map((item) => item.TotalOrders);
  const Current6MonthsNewClients = chartData.map((item) => item.Current6MonthsNewClients);
  const Current6MonthsRevenue = chartData.map((item) => item.Current6MonthsRevenue);
  // const Previous6MonthsNewClients = chartData.map((item) => item.Previous6MonthsNewClients);
  // const Previous6MonthsRevenue = chartData.map((item) => item.Previous6MonthsNewClients);

  const xAxisData =
    endpoint === "New_Client_Acquisition_6mon"
      // ? [{ data: Current6MonthsNewClients, scaleType: "band", label: "New Clients (Current 6 Months)" }]
      ? [{ data: Current6MonthsRevenue, scaleType: "band", label: "Clients / Revenue" }]
      // endpoint === "CRM_COORDINATOR_PERFORM"
      //   ? [{ data: coordinatorName, scaleType: "band", label: "Coordinator" }]
      //   : endpoint === "CRM_SALESMAN_PERFORM"
      //   ? [{ data: salesperson, scaleType: "band", label: "Salesperson" }]
      //   : endpoint === "CRM_CUSTOMER_AQUI"
      //   ? [{ data: month, scaleType: "band", label: "Month" }]
      //   : endpoint === "New_Client_Acquisition_6mon"
      //   ? [{ data: Previous6MonthsNewClients, scaleType: "band", label: "New Clients (Previous 6 Months)" }]
      : [];

  const yAxisData =
    endpoint === "New_Client_Acquisition_6mon"
      ? { data: Current6MonthsNewClients }
      // endpoint === "CRM_COORDINATOR_PERFORM"
      //   ? { data: totalOrders }
      //   : endpoint === "CRM_SALESMAN_PERFORM"
      //   ? { data: totalOrders }
      //   : endpoint === "CRM_CUSTOMER_AQUI"
      //   ? { data: newCustomers }
      //   : endpoint === "New_Client_Acquisition_6mon"
      //   ? { data: Previous6MonthsRevenue }
      : [];

  const rotatedXAxis =
    barChartTitle !== "COORDINATOR PERFORMANCE"
      ? xAxisData.map((axis) => ({
        ...axis,
        tickLabelStyle: {
          // angle: 90,
          textAnchor: "start",
          verticalAnchor: "middle",
        },
      }))
      : xAxisData;

  return (
    <div className="p-2 w-full overflow-x-auto">
      <h2 className="text-lg font-semibold mb-2 text-center text-gray-700">{barChartTitle}</h2>

      {loading ? (
        <p className="text-center text-gray-500">Loading chart...</p>
      ) : totalOrders.length > 0 ? (
        <div className="min-w-[360px]">
          <BarChart
            series={[yAxisData]}
            xAxis={rotatedXAxis}
            height={300}
            width={Math.max(350, (rotatedXAxis[0]?.data.length || 1) * 40)}
            margin={{ top: 20, bottom: 100, left: 40, right: 10 }}
            colors={[barColor]}
            yAxis={[{ label: yAxisTitle }]}
          />
        </div>
      ) : (
        <p className="text-center text-gray-400">No data available</p>
      )}
    </div>
  );
};

export default SalesBarChart2;